import { useState, useEffect } from "react";
import { api } from "../../context";
export default function Subscribers({ t }) {
  const CARD=t.card,BORDER=t.border,TEXT=t.text,SUB=t.sub,GRN=t.grn,RED=t.red,GOLD=t.gold,PRI=t.pri;
  const [data, setData] = useState(null);
  useEffect(() => { api("/admin/dashboard").then(r => { if (r.ok) setData(r.data); }); }, []);
  if (!data) return <div style={{ color: SUB, padding: 40 }}>Loading...</div>;
  const subs = (data.members || []).filter(u => u.plan === "premium" || u.plan === "elite");
  return (
    <div>
      <div style={{ fontSize: 22, fontWeight: 800, color: TEXT, marginBottom: 4 }}>Subscribers</div>
      <div style={{ fontSize: 12, color: SUB, marginBottom: 24 }}>All premium and elite members — live from MySQL</div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 24 }}>
        {[{l:"Total Paid",v:subs.length,c:PRI},{l:"Premium",v:data.plans?.premium||0,c:GRN},{l:"Elite",v:data.plans?.elite||0,c:GOLD},{l:"Expired",v:0,c:RED}].map((s,i)=>(
          <div key={i} style={{background:CARD,border:`1px solid ${BORDER}`,borderRadius:12,padding:"18px 20px"}}>
            <div style={{fontSize:10,fontWeight:700,color:SUB,textTransform:"uppercase",letterSpacing:1,marginBottom:8}}>{s.l}</div>
            <div style={{fontSize:28,fontWeight:800,color:s.c}}>{s.v}</div>
          </div>
        ))}
      </div>
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "#0d1420", borderBottom: `2px solid ${BORDER}` }}>
              {["Name","Email","Plan","Age","Location","Orientation","Trust","Joined","Status"].map(h=>(
                <th key={h} style={{padding:"12px 16px",textAlign:"left",color:SUB,fontWeight:600,fontSize:11,textTransform:"uppercase"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {subs.map((u,i)=>(
              <tr key={u.id} style={{borderBottom:`1px solid ${BORDER}20`,background:i%2===0?"transparent":"#ffffff04"}}>
                <td style={{padding:"12px 16px",color:TEXT,fontWeight:700}}>{u.name}</td>
                <td style={{padding:"12px 16px",color:SUB,fontSize:12}}>{u.email}</td>
                <td style={{padding:"12px 16px"}}><span style={{padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700,background:u.plan==="elite"?`${GOLD}20`:`${GRN}20`,color:u.plan==="elite"?GOLD:GRN}}>{u.plan}</span></td>
                <td style={{padding:"12px 16px",color:SUB}}>{u.age||"—"}</td>
                <td style={{padding:"12px 16px",color:SUB}}>{u.location||"—"}</td>
                <td style={{padding:"12px 16px",color:SUB}}>{u.orientation||"—"}</td>
                <td style={{padding:"12px 16px",color:GOLD,fontWeight:700}}>{u.trust_score}</td>
                <td style={{padding:"12px 16px",color:SUB,fontSize:12}}>{u.created_at?new Date(u.created_at).toLocaleDateString():"—"}</td>
                <td style={{padding:"12px 16px"}}><span style={{padding:"3px 10px",borderRadius:20,fontSize:11,fontWeight:700,background:u.is_banned?`${RED}20`:`${GRN}20`,color:u.is_banned?RED:GRN}}>{u.is_banned?"Banned":"Active"}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}